import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const CardList = styled.ul(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)',
    gridGap: [
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
    ],
    width: '100%',
    marginTop: [
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
    ],
  }),
);

export const Card = styled.li(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      '32px 64px',
      '32px 64px',
    ],
  }),
);

export const CardHeader = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const CancelText = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.l,
    fontWeight: 'bold',
    color: defaultTheme.text.gray,
  }),
);

export const ProgramName = styled.p(() =>
  mq({
    fontSize: [
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
    ],
    fontWeight: 'bold',
    lineHeight: defaultTheme.font.height.base,
    textAlign: 'left',
  }),
);
